<template>
  <div class="p-4">
    <RadioGroup v-model="language" class="flex flex-col gap-2 w-full">
      <label
        v-for="item in items"
        :key="item.key"
        :for="item.key"
        class="flex items-center space-x-2 p-3 cursor-pointer rounded-6xl"
        :class="[language === item.key && 'bg-key']"
      >
        <RadioGroupItem
          :id="item.key"
          :value="item.key"
          type="circle"
          :class="[language === item.key ? 'border-brand-blue1' : 'border-black-white']"
        />
        <span
          class="text-m-medium"
          :class="[language === item.key ? 'text-brand-blue1' : 'text-black-white']"
        >
          {{ item.name }}
        </span>
      </label>
    </RadioGroup>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { RadioGroup, RadioGroupItem } from '@rapoo/element'
  import { useI18n } from 'vue-i18n'
  import { useLocaleStore } from '@/stores/locale'
  import { storeToRefs } from 'pinia'
  import { EN_US_LOCALE, ZH_CN_LOCALE } from '@/utils/locale'

  const localeStore = useLocaleStore()
  const { language } = storeToRefs(localeStore)
  const { t } = useI18n()

  const items = computed(() => [
    { name: t('setting.languages.zhCN'), key: ZH_CN_LOCALE },
    { name: t('setting.languages.enUS'), key: EN_US_LOCALE },
  ])
</script>

<style lang="scss" scoped></style>
